import React, { Component } from 'react';
import { Box, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@material-ui/core';
import IncomeDetails from './IncomeDetails';
import { isEmpty } from 'lodash-es';
import PopUp from '../../../commonModules/interface/PopUp';
import { Alert } from '@material-ui/lab';
import Currency from '../../../commonModules/Currency';


class PaymentSingle extends Component {
    state = { 
        income: {},
        noMatch: true,
        errors: {
            incomeID: ""
        }
    }

    componentDidMount() {
        console.log('====================================');
        console.log(this.props.payment);
        console.log('====================================');
        this.getIncome()
    }
    getIncome = async () => {
        if (this.props.payment.income_id){
            const res = await this.props.getIncomeInfo(this.props.payment.income_id)
            console.log('====================================');
            console.log({res});
            console.log('====================================');
            if (!res.error && res.income_amount !== 0) {
                this.setState({
                    income: res,
                    errors: {
                        incomeID: ""
                    }
                })
            } else {
                this.setState({
                    noMatch: true
                })
            }
        } else {
            this.setState({
                errors: {
                    incomeID: "Veuillez remplir ce champ"
                }
            })
        }
    }

    render() {
        const { payment } = this.props;
        const {noMatch, income} = this.state;
        return (
            <PopUp
                title={`Paiement n°${payment.transactionId} ` }
                close={this.props.handleClose}
                // submitAction={ isEmpty(income) ?  this.getIncome : this.validate}
                // submitTitle={isEmpty(income) ? "Rechercher": "Valider"}
                // submitColor={isEmpty(income) && "primary" }
                appbar
                // disabledSubmit={isEmpty(this.props.incomeID)}
            >
                <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                    <Box p={1}>
                        {!noMatch && !isEmpty(income) &&
                            <IncomeDetails income={income} />
                        }
                        {noMatch &&
                            <Alert severity="warning">Pas de recette liée</Alert>
                        }
                    </Box>
                </Grid>
                    <Grid item xs={12} sm={6}>
                        <List style={{ maxHeight: "500px", overflow: "auto"}}>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Date du paiement</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {new Date(payment.timePayment).toLocaleString('fr-FR')}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Box ID</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.boxId}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Montant</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                <Currency value={payment.money} />
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Durée</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {`${payment.day} jour${payment.day > 1 && "s"}`} 
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Code</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.codeId}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Info</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.info}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Type de paiement</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="body1" color="secondary" >
                                                {payment.typePayment}
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            
                        </List>
                    </Grid>
                </Grid>
                
            </PopUp>
        );
    }
}

export default PaymentSingle;

// {
//     "paymentID": "pd1665570661_126458",
//     "type": "paymentDescription",
//     "accountID": "1576577560-VUWSP2NcHciWvqZ",
//     "recordPayment": "2022-10-12T10:31:08.458085283Z",
//     "transactionId": "16655255194307327",
//     "methodPayment": "Angaza-Manual",
//     "typePayment": "Angaza-Manual",
//     "boxId": "66873225",
//     "boxAssoId": "1597398512-HiZEEthDsGSWMIZ",
//     "money": 10000,
//     "day": 30,
//     "kwh": 0,
//     "timePayment": "2022-10-11T22:00:36Z",
//     "codeId": "*749 383 099 483 08#",
//     "currency": "XOF",
//     "sessionToken": "16655255194307327",
//     "info": "Pay by +22997414740",
//     "codeUniqueId": "16655255194307327",
//     "extraInfo": "1665570668-3d514c38-c216-4",
//     "externalpartnerid": "PA376935230"
// }